import { IRouteState } from './../../../../../app.common/modules/routes/models';
import * as angular from 'angular';
import { InventoryService } from '../../inventory.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';
import { Open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements as categoryWithItemTypesAndMeasurements } from '../../../model/open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements';
import { AccountService } from '../../../account/account.service';

class HelpDictionaryController implements ng.IComponentController {
    static $inject = ['inventoryService', 'notificationService', '$state', '$translate', '$location'];

    waiting: boolean;
    items: categoryWithItemTypesAndMeasurements[];
    isNotPublicRoute: boolean;

    constructor(
        private readonly inventoryService: InventoryService,
        private readonly notificationServcie: NotificationService,
        private readonly $state: StateService,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $location: ng.ILocationService,
    ) {
    }

    goToProductsImport() {
        this.$state.go('app.operations');
    }

    goToHelp() {
        this.$state.go('app.help.manual');
    }

    async $onInit() {
        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
        this.waiting = true;

        try {
            let response = await this.inventoryService.getClassificationDictionary();
            this.items = response;
        } catch (e) {
            this.notificationServcie.showErrorMessage(e);
        }

        this.waiting = false;
    }
}

angular
    .module('naut')
    .component('helpDictionary', {
        controller: HelpDictionaryController,
        template: require('./help-dictionary.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/help-dictionary/help-dictionary.component.ts